(function () {
  function initMarquee(root) {
    var track = root.querySelector('.scrolling-text-banner__track');
    var group = root.querySelector('.scrolling-text-banner__group');
    if (!track || !group) return;

    var pxPerSecond = parseFloat(root.dataset.speed) || 40;
    var direction = root.dataset.direction === 'ltr' ? 'ltr' : 'rtl';
    var pauseOnHover = root.dataset.pauseOnHover === 'true';

    var prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    if (prefersReducedMotion) return;

    var animation = null;

    function play() {
      if (animation) {
        animation.cancel();
      }

      var groupWidth = group.getBoundingClientRect().width;
      if (!groupWidth) return;

      var duration = (groupWidth / pxPerSecond) * 1000; // ms

      var keyframes =
        direction === 'ltr'
          ? [{ transform: 'translateX(-50%)' }, { transform: 'translateX(0)' }]
          : [{ transform: 'translateX(0)' }, { transform: 'translateX(-50%)' }];

      animation = track.animate(keyframes, {
        duration: duration,
        iterations: Infinity,
        easing: 'linear',
      });

      if (pauseOnHover) {
        root.addEventListener('mouseenter', function () {
          animation.pause();
        });
        root.addEventListener('mouseleave', function () {
          animation.play();
        });
      }
    }

    play();

    // Herbereken bij resize (debounced), zodat snelheid consistent blijft
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(play, 200);
    });

    // Herbereken zodra fonts geladen zijn (kan breedte beïnvloeden)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(play);
    }
  }

  function initAll() {
    document.querySelectorAll('.scrolling-text-banner').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor: herinitialiseer bij section reload
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.scrolling-text-banner');
    if (root) initMarquee(root);
  });
})();